module.exports = __webpack_public_path__ + "static/media/Need Help Icon.8958a36b.svg";